import type { Funcionario } from "../../types/funcionarios";
import { apiClient } from "../core/apiClient";


interface getFuncionarioResult {
  data: Funcionario[];
  pagination: {
    currentPage: number,
    totalPages: number,
    totalItems: number,
    itemsPerPage: number,
    itemsInCurrentPage: number,
    hasNextPage: boolean,
    hasPreviousPage: boolean,
    nextPage: string | null,
    previousPage: string | null
  }
  loading: boolean;
  error: string | null;
  total: number;
  totalPages: number;
  refetch: () => void;
}

export class FuncionarioService {
  async getList(params?: { name?: string; page?: number; area_id?: string }): Promise<getFuncionarioResult> {

    const queryString = params ? new URLSearchParams(params as any).toString() : '';
    const endpoint = `/funcionarios${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<getFuncionarioResult>(endpoint);
    return response.data;
  }
}

export const funcionarioService = new FuncionarioService();